import React from 'react';
import { StyleSheet, Text, View, Platform, useWindowDimensions } from 'react-native';
import { FontFamily } from '../../../../../constants/fonts';

export interface ExecutionRecapMetric {
  label: string;
  value: string;
  subtext: string;
}

interface ExecutionRecapCardsProps {
  title: string;
  note?: string;
  metrics: ExecutionRecapMetric[];
}

const ExecutionRecapCards: React.FC<ExecutionRecapCardsProps> = ({ title, note, metrics }) => {
  const { width } = useWindowDimensions();
  const isMobileIos = Platform.OS === 'ios' && width < 768;
  
  return (
    <View style={styles.card}>
      <View style={[styles.headerRow, Platform.OS === 'web' && styles.headerRowWeb]}>
        <Text style={styles.title}>{title}</Text>
        {note ? <Text style={[styles.note, Platform.OS === 'web' && styles.noteWeb]}>{note}</Text> : null}
      </View>

      <View style={styles.metricRow}>
        {metrics.map((metric, index) => (
          <View
            key={metric.label}
            style={[styles.metricCol, index === metrics.length - 1 ? styles.metricColLast : null]}
          >
            <Text style={[styles.value, isMobileIos && styles.valueMobileIos]}>{metric.value}</Text>
            <Text style={styles.label}>{metric.label}</Text>
            <Text style={styles.subtext}>{metric.subtext}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#DEE7F2',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  headerRow: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 10,
    gap: 4,
  },
  title: {
    fontSize: 16,
    fontFamily: FontFamily.bold,
    fontWeight: '700',
    color: '#1A1D21',
  },
  note: {
    fontSize: 10,
    fontFamily: FontFamily.regular,
    color: '#838383',
    fontWeight: '600',
  },
  headerRowWeb: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    columnGap: 12,
  },
  noteWeb: {
    marginLeft: 12,
    flexShrink: 1,
    textAlign: 'right',
  },
  metricRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  metricCol: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: '#E4ECF7',
    paddingRight: 14,
    marginRight: 14,
    paddingVertical: 2,
    minWidth: 0,
  },
  metricColLast: {
    borderRightWidth: 0,
    paddingRight: 0,
    marginRight: 0,
  },
  value: {
    fontSize: 42,
    color: '#0B5FC6',
    fontWeight: '700',
    lineHeight: 44,
  },
  valueMobileIos: {
    fontSize: 28,
    lineHeight: 32,
  },
  label: {
    marginTop: 2,
    fontSize: 12,
    color: '#334155',
    fontWeight: '600',
  },
  subtext: {
    marginTop: 1,
    fontSize: 10,
    color: '#7D8898',
    fontWeight: '500',
  },
});

export default ExecutionRecapCards;
